import { Link } from "react-router-dom";

const Logo = ({ variant = "dark", testId = "logo-link" }) => {
  const isDark = variant === "dark";

  const lexClr = isDark ? "text-white" : "text-[#090a0f]";
  const dotClr = isDark ? "text-[#00e5ff]" : "text-[#0047ff]";
  const dividerClr = isDark ? "bg-white/25" : "bg-[#090a0f]/15";
  const subClr = isDark ? "text-white/55" : "text-[#52525b]";
  const productClr = isDark ? "text-white/85" : "text-[#52525b]";

  return (
    <Link
      to="/"
      data-testid={testId}
      className="flex items-center gap-3 sm:gap-4 group"
      aria-label="Sentinel by Lexifide.ai — home"
    >
      <span
        className={`font-display font-bold text-[18px] sm:text-[19px] tracking-[-0.01em] leading-none ${lexClr}`}
      >
        LEXIFIDE<span className={dotClr}>.</span>AI
      </span>
      <span className={`hidden sm:block w-px h-6 ${dividerClr}`} aria-hidden="true" />
      <span className="hidden sm:flex flex-col leading-none">
        <span className={`font-display font-semibold text-[14px] tracking-tight ${productClr}`}>
          Sentinel
        </span>
        <span
          className={`font-mono text-[9px] tracking-[0.24em] uppercase mt-1.5 ${subClr}`}
        >
          Compliance Intelligence Overlay
        </span>
      </span>
    </Link>
  );
};

export default Logo;
